var _ellipse, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_4170",
    "data-name": "Group 4170",
    xmlns: "http://www.w3.org/2000/svg",
    width: 63.808,
    height: 63.865,
    viewBox: "0 0 63.808 63.865",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1690",
    "data-name": "Ellipse 1690",
    cx: 30.942,
    cy: 30.942,
    rx: 30.942,
    ry: 30.942,
    transform: "translate(0.991 0.893)",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4149",
    "data-name": "Group 4149",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1702",
    "data-name": "Ellipse 1702",
    cx: 25.552,
    cy: 25.552,
    rx: 25.552,
    ry: 25.552,
    transform: "translate(6.388 6.388)",
    fill: "#e80000"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4140",
    "data-name": "Group 4140",
    transform: "translate(9.449 10.396)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4139",
    "data-name": "Group 4139"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4135",
    "data-name": "Group 4135",
    transform: "translate(0 4.28)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4134",
    "data-name": "Group 4134"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13932",
    "data-name": "Path 13932",
    d: "M4198.672,1511.2a1.2,1.2,0,0,1-1.2-1.2,22.493,22.493,0,0,1,7.731-16.97,1.2,1.2,0,1,1,1.573,1.807A20.1,20.1,0,0,0,4199.87,1510,1.2,1.2,0,0,1,4198.672,1511.2Z",
    transform: "translate(-4197.474 -1492.734)",
    fill: "#ff5757"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4138",
    "data-name": "Group 4138",
    transform: "translate(10.776)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4137",
    "data-name": "Group 4137"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4136",
    "data-name": "Group 4136"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13933",
    "data-name": "Path 13933",
    d: "M4322.568,1447.755a1.2,1.2,0,0,1-.593-2.239,22.412,22.412,0,0,1,4.457-1.93,1.2,1.2,0,0,1,.708,2.289,20,20,0,0,0-3.979,1.724A1.194,1.194,0,0,1,4322.568,1447.755Z",
    transform: "translate(-4321.37 -1443.532)",
    fill: "#ff5757"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4147",
    "data-name": "Group 4147",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4142",
    "data-name": "Group 4142"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4141",
    "data-name": "Group 4141"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13934",
    "data-name": "Path 13934",
    d: "M4120.781,1387.879a31.933,31.933,0,1,1,22.585-54.51,1.2,1.2,0,0,1-1.694,1.694,29.545,29.545,0,1,0,0,41.782,1.2,1.2,0,0,1,1.693,1.694A31.845,31.845,0,0,1,4120.781,1387.879Z",
    transform: "translate(-4088.841 -1324.014)",
    fill: "#e80000"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4144",
    "data-name": "Group 4144",
    transform: "translate(60.823 34.289)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4143",
    "data-name": "Group 4143"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13935",
    "data-name": "Path 13935",
    d: "M4789.314,1723.437a1.2,1.2,0,0,1-1.173-1.445c.188-.89.335-1.8.439-2.7a1.2,1.2,0,0,1,2.38.275c-.113.977-.273,1.96-.475,2.922A1.2,1.2,0,0,1,4789.314,1723.437Z",
    transform: "translate(-4788.115 -1718.228)",
    fill: "#e80000"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4146",
    "data-name": "Group 4146",
    transform: "translate(57.907 16.333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4145",
    "data-name": "Group 4145"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13936",
    "data-name": "Path 13936",
    d: "M4759.295,1526.48a1.2,1.2,0,0,1-1.194-1.116,29.458,29.458,0,0,0-3.368-11.817,1.2,1.2,0,1,1,2.116-1.123,31.847,31.847,0,0,1,3.642,12.777,1.2,1.2,0,0,1-1.113,1.277Z",
    transform: "translate(-4754.593 -1511.788)",
    fill: "#e80000"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_13937",
    "data-name": "Path 13937",
    d: "M4331.3,1606.322a12.816,12.816,0,0,0-.541-2.986,3.767,3.767,0,0,0-3.218-2.747c-.979-.139-1.971-.192-2.959-.233-1.829-.075-3.659-.141-5.489-.158-2.287-.022-4.574-.009-6.861.023-1.765.025-3.53.091-5.294.161a14.692,14.692,0,0,0-2.913.283,3.638,3.638,0,0,0-2.39,1.764,6.46,6.46,0,0,0-.775,2.443c-.121.98-.223,1.966-.264,2.953a71.377,71.377,0,0,0,.071,8.316,12.75,12.75,0,0,0,.6,3.4,3.715,3.715,0,0,0,1.885,2.216,6.774,6.774,0,0,0,2.468.555c1.1.094,2.211.133,3.318.164,2.357.066,4.715.112,7.073.167,0-.021,0-.041,0-.062,1.173,0,2.346.025,3.519-.005q3.2-.083,6.406-.225a11.543,11.543,0,0,0,2-.234,3.6,3.6,0,0,0,2.609-2.119,6.9,6.9,0,0,0,.61-2.166c.135-1.369.266-2.742.3-4.116A66.016,66.016,0,0,0,4331.3,1606.322Z",
    transform: "translate(-4282.096 -1576.166)",
    fill: "#a50404"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4148",
    "data-name": "Group 4148",
    transform: "translate(16.082 21.493)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13938",
    "data-name": "Path 13938",
    d: "M4289.229,1593.573c-2.357-.054-4.716-.1-7.073-.167-1.106-.031-2.215-.07-3.317-.164a6.772,6.772,0,0,1-2.468-.555,3.717,3.717,0,0,1-1.886-2.216,12.768,12.768,0,0,1-.6-3.4,71.377,71.377,0,0,1-.071-8.316c.042-.987.143-1.973.264-2.953a6.46,6.46,0,0,1,.776-2.443,3.636,3.636,0,0,1,2.389-1.764,14.718,14.718,0,0,1,2.914-.283c1.764-.071,3.528-.137,5.293-.161,2.287-.032,4.574-.045,6.861-.023,1.83.018,3.66.083,5.489.158.988.041,1.981.094,2.959.233a3.767,3.767,0,0,1,3.218,2.747,12.841,12.841,0,0,1,.541,2.986,66.132,66.132,0,0,1,.148,7.394c-.034,1.374-.165,2.747-.3,4.116a6.884,6.884,0,0,1-.61,2.166,3.6,3.6,0,0,1-2.609,2.119,11.525,11.525,0,0,1-2,.234q-3.2.141-6.406.225c-1.172.03-2.346.005-3.519.005C4289.23,1593.532,4289.23,1593.552,4289.229,1593.573Zm-3.206-16.081v8.977l8.366-4.473Z",
    transform: "translate(-4273.731 -1571.116)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13939",
    "data-name": "Path 13939",
    d: "M4392.253,1624.341l10.254,5.52a.751.751,0,0,1,0,1.314l-10.254,5.483a.723.723,0,0,1-1.057-.656V1625A.723.723,0,0,1,4392.253,1624.341Z",
    transform: "translate(-4380.978 -1619.633)",
    fill: "#e80000"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.7226fad701fe2aa6f6f873a7edf2ca29.svg";
export { ForwardRef as ReactComponent };